module.exports = __webpack_public_path__ + "static/img/rzlc.e88c5904.png";